import {
  AppRoutePaths,
  HirePurchaseRoutePaths,
  SmallLoanRoutePaths,
} from 'app-constants';

export type OfferProductPaths = {
  offerIncomeInsurancePath: string;
  offerNewsletterPath: string;
  offerWithdrawalPath: string;
};

/** Map of offer product base path -> offer sub-routes. Add new product types here. */
export const OFFER_PRODUCT_ROUTE_MAP: Record<string, OfferProductPaths> = {
  [AppRoutePaths.HIRE_PURCHASE]: {
    offerIncomeInsurancePath: HirePurchaseRoutePaths.OFFER_INCOME_INSURANCE,
    offerNewsletterPath: HirePurchaseRoutePaths.OFFER_NEWSLETTER,
    offerWithdrawalPath: HirePurchaseRoutePaths.OFFER_CREDIT_ACCOUNT_WITHDRAWAL,
  },
  [AppRoutePaths.SMALL_LOAN]: {
    offerIncomeInsurancePath: SmallLoanRoutePaths.OFFER_INCOME_INSURANCE,
    offerNewsletterPath: SmallLoanRoutePaths.OFFER_NEWSLETTER,
    offerWithdrawalPath: SmallLoanRoutePaths.OFFER_CREDIT_ACCOUNT_WITHDRAWAL,
  },
};

const DEFAULT_OFFER_PRODUCT = AppRoutePaths.HIRE_PURCHASE;

export type OfferRedirectPaths = {
  offerBasePath: string;
  offerIncomeInsurancePath: string;
  offerNewsletterPath: string;
  offerWithdrawalPath: string;
  hasOfferProductFromUrl: boolean;
};

/** First path segment (e.g. /small-loan/offer-... -> 'small-loan'). Use for offer_product from current route. */
export const getOfferProductFromPathname = (pathname: string): string => {
  const segment = pathname.split('/').filter(Boolean)[0];
  return segment ?? DEFAULT_OFFER_PRODUCT;
};

export const getOfferRedirectPaths = (
  offerProductFromUrl: string | null,
): OfferRedirectPaths => {
  const entry =
    offerProductFromUrl != null
      ? OFFER_PRODUCT_ROUTE_MAP[offerProductFromUrl]
      : undefined;
  const hasOfferProductFromUrl = entry != null;

  const basePath =
    hasOfferProductFromUrl && offerProductFromUrl != null
      ? offerProductFromUrl
      : DEFAULT_OFFER_PRODUCT;
  const paths = entry ?? OFFER_PRODUCT_ROUTE_MAP[DEFAULT_OFFER_PRODUCT];

  return {
    offerBasePath: basePath,
    offerIncomeInsurancePath: paths.offerIncomeInsurancePath,
    offerNewsletterPath: paths.offerNewsletterPath,
    offerWithdrawalPath: paths.offerWithdrawalPath,
    hasOfferProductFromUrl,
  };
};
